// 이미지 경로
const DEV_IMG_URL = 'https://s3.ap-northeast-2.amazonaws.com/fdding-dev-image'
const PROD_IMG_URL = 'https://s3.ap-northeast-2.amazonaws.com/fdding-prod-image'
export const IMG_URL = process.env.NODE_ENV === 'development' ? DEV_IMG_URL : PROD_IMG_URL

const DEV_ETC_IMG_URL = 'https://s3.ap-northeast-2.amazonaws.com/fdding-dev-etc-image'
const PROD_ETC_IMG_URL = 'https://s3.ap-northeast-2.amazonaws.com/fdding-prod-etc-image'
export const ETC_IMG_URL = process.env.NODE_ENV === 'development' ? DEV_ETC_IMG_URL : PROD_ETC_IMG_URL

// 이미지 path
export const IMG_PATH = ['logo', 'business', 'etc', 'album', 'review', 'jeju', 'main', 'simple', 'dme']




// WEBPACK FOOTER //
// ./client/utils/imageUrl.js